

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";
// getAllBlogSections
// GETALLBLOGSECTIONS
const GETALLBLOGSECTIONS= createAsyncThunk(
  "getAllBlogSections/getAllBlogSections",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllBlogSectionsSlice = createSlice({
  name: "getAllBlogSectionsSlice",
  initialState: {
    PublishPost: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(GETALLBLOGSECTIONS.fulfilled, (state, action) => {
      state.getAllBlogSections = {
        ...state.getAllBlogSections,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLBLOGSECTIONS.pending, (state, action) => {
      state.getAllBlogSections = {
        ...state.getAllBlogSections,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLBLOGSECTIONS.rejected, (state, action) => {
      state.getAllBlogSections = {
        ...state.getAllBlogSections,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllBlogSectionsAction = {
  GETALLBLOGSECTIONS,
};

export { getAllBlogSectionsAction };
export default getAllBlogSectionsSlice.reducer;
